import { getPlatformLogo, type SOURCE_PLATFORM_TYPE } from '@/entities/public-filter/constants';
import { ProfileImage } from '@/shared/components/profile-image';
import { formatRelativeTime } from '@/shared/utils/format-relative-time';

interface CreatorProfileProps {
  username: string;
  displayName: string;
  avatar: string;
  postedAt?: DateISOString;
  onProfileClick: (e: React.MouseEvent) => void;
  platform: SOURCE_PLATFORM_TYPE;
}

export function CreatorProfile({
  username,
  displayName,
  avatar,
  postedAt,
  onProfileClick,
  platform,
}: CreatorProfileProps) {
  const PlatformLogo = getPlatformLogo(platform);

  return (
    <div onClick={onProfileClick} className="group flex items-center gap-3 p-4">
      <ProfileImage src={avatar} name={username} className="size-10 rounded-full object-cover" />
      <div className="flex-1">
        <div className="flex w-full cursor-pointer items-center gap-1">
          <span className="max-w-[90px] truncate font-semibold text-zinc-950 group-hover:underline">
            {username}
          </span>
          <PlatformLogo className="size-4" />
        </div>
        <div className="flex items-center gap-1 text-sm text-zinc-500 group-hover:underline">
          <span className="max-w-[90px] truncate">{displayName}</span>
          {postedAt && (
            <>
              <span>·</span>
              <span>{formatRelativeTime(postedAt)}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
